import Vue from 'vue';
import UpgradeModal from '~/components/modal/upgradeModal.vue';

/**
 * Upgrade Modal Plugin
 *
 * Makes the upgrade modal globally available throughout the app
 * Can be accessed via this.$upgradeModal in components
 */
export default (context, inject) => {
  // Create a singleton instance of the upgrade modal
  const UpgradeModalConstructor = Vue.extend(UpgradeModal);
  const upgradeModalInstance = new UpgradeModalConstructor();

  // Mount the modal to the body
  const mountPoint = document.createElement('div');
  document.body.appendChild(mountPoint);
  upgradeModalInstance.$mount(mountPoint);

  // Inject into Vue context
  inject('upgradeModal', upgradeModalInstance);

  // Also make it globally available on window for axios interceptor
  if (typeof window !== 'undefined') {
    window.$upgradeModal = upgradeModalInstance;
  }
};
